/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropMemberPointsResponse
 */
export interface DropMemberPointsResponse {
    /**
     * 
     * @type {string}
     * @memberof DropMemberPointsResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DropMemberPointsResponse
     */
    dropId: string;
    /**
     * 
     * @type {string}
     * @memberof DropMemberPointsResponse
     */
    userId: string;
    /**
     * 
     * @type {number}
     * @memberof DropMemberPointsResponse
     */
    balance: number;
    /**
     * 
     * @type {number}
     * @memberof DropMemberPointsResponse
     */
    totalEarned: number;
    /**
     * 
     * @type {number}
     * @memberof DropMemberPointsResponse
     */
    monthlyPointsEarned: number;
    /**
     * 
     * @type {number}
     * @memberof DropMemberPointsResponse
     */
    lastEarnedAt?: number;
}

/**
 * Check if a given object implements the DropMemberPointsResponse interface.
 */
export function instanceOfDropMemberPointsResponse(value: object): value is DropMemberPointsResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('dropId' in value) || value['dropId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('balance' in value) || value['balance'] === undefined) return false;
    if (!('totalEarned' in value) || value['totalEarned'] === undefined) return false;
    if (!('monthlyPointsEarned' in value) || value['monthlyPointsEarned'] === undefined) return false;
    return true;
}

export function DropMemberPointsResponseFromJSON(json: any): DropMemberPointsResponse {
    return DropMemberPointsResponseFromJSONTyped(json, false);
}

export function DropMemberPointsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropMemberPointsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dropId': json['dropId'],
        'userId': json['userId'],
        'balance': json['balance'],
        'totalEarned': json['totalEarned'],
        'monthlyPointsEarned': json['monthlyPointsEarned'],
        'lastEarnedAt': json['lastEarnedAt'] == null ? undefined : json['lastEarnedAt'],
    };
}

export function DropMemberPointsResponseToJSON(json: any): DropMemberPointsResponse {
    return DropMemberPointsResponseToJSONTyped(json, false);
}

export function DropMemberPointsResponseToJSONTyped(value?: DropMemberPointsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'dropId': value['dropId'],
        'userId': value['userId'],
        'balance': value['balance'],
        'totalEarned': value['totalEarned'],
        'monthlyPointsEarned': value['monthlyPointsEarned'],
        'lastEarnedAt': value['lastEarnedAt'],
    };
}

